import { FC } from 'react';

import { LocaleSettingsContextProvider } from '@onlinepayments/payments-library';
import { Route, HashRouter as Router } from 'react-router-dom';

import { ErrorBoundary } from './components/toolkit';
import { APP } from './config';
import ConfirmationPage from './containers/ConfirmationPage';
import LinkPage from './containers/LinkPage';
import ProcessingPaymentPage from './containers/ProcessingPaymentPage';
import ReviewAndPayContainer from './containers/ReviewAndPayContainer';
import ValidateOrderContainer from './containers/ValidateOrder';
import ValidateOrderFailureContainer from './containers/ValidateOrderFailure';
import { Path } from './enums/Path';
import { PaymentLibraryContext } from './PaymentLibraryContext';
import { PayorderContextProvider } from './PayorderContext';
import { getCountryAndLanguage } from './utils/localization';

// Styles from IKEA design system
import '@ingka/core/dist/style.css';
import '@ingka/focus/dist/style.css';
import './App.scss';
import './styles/utility-classes.scss';

const App: FC = () => {
  const { countryCode, languageCode } = getCountryAndLanguage();

  return (
    <div className="App">
      <LocaleSettingsContextProvider
        assetsBaseUrl={window.payorder.PAYMENT_ASSETS_BASE_URL}
        app={APP}
        languageCode={languageCode}
        countryCode={countryCode}
      >
        <PayorderContextProvider>
          <PaymentLibraryContext>
            <Router>
              <ErrorBoundary>
                <Route exact path="/" component={ValidateOrderContainer} />
                <Route path={Path.Link} component={LinkPage} />
                <Route path={Path.ReviewAndPay} component={ReviewAndPayContainer} />
                <Route path={Path.ValidateOrderFailure} component={ValidateOrderFailureContainer} />
                <Route path={Path.ProcessingPayment} component={ProcessingPaymentPage} />
                <Route path={Path.Confirmation} component={ConfirmationPage} />
              </ErrorBoundary>
            </Router>
          </PaymentLibraryContext>
        </PayorderContextProvider>
      </LocaleSettingsContextProvider>
    </div>
  );
};

export default App;
